import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { MapContainer, TileLayer, Marker, Popup, CircleMarker } from "react-leaflet";
import L from "leaflet";

// Fix default icon
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

export default function DispatcherMap() {
  const [facilities, setFacilities] = useState([]);
  const [pros, setPros] = useState([]);

  useEffect(() => {
    api.get("/facilities").then((r) => setFacilities(r.data));
    api.get("/professionals").then((r) => setPros(r.data));
  }, []);

  return (
    <div className="space-y-6" data-testid="dispatcher-map">
      <div>
        <h1 className="text-3xl font-bold text-brand-navy" style={{ fontFamily: "Outfit, sans-serif" }}>Map Matching</h1>
        <p className="text-slate-500 mt-1">Facilities (navy pins) and available professionals (teal dots) in the GTA.</p>
      </div>
      <Card>
        <CardContent className="p-0 h-[600px]">
          <MapContainer center={[43.6532, -79.3832]} zoom={11} style={{ height: "100%" }}>
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" attribution='&copy; OpenStreetMap' />
            {facilities.map((f) =>
              f.latitude && f.longitude ? (
                <Marker key={f.id} position={[f.latitude, f.longitude]}>
                  <Popup>
                    <div className="font-semibold">{f.name}</div>
                    <div className="text-xs">{f.facility_type}</div>
                    <div className="text-xs">{f.address}, {f.city}</div>
                  </Popup>
                </Marker>
              ) : null
            )}
            {pros.map((p) =>
              p.latitude && p.longitude ? (
                <CircleMarker
                  key={p.id}
                  center={[p.latitude, p.longitude]}
                  radius={8}
                  pathOptions={{ color: p.available_now ? "#16B3A8" : "#0B67C2", fillColor: p.available_now ? "#16B3A8" : "#0B67C2", fillOpacity: 0.7 }}
                >
                  <Popup>
                    <div className="font-semibold">{p.first_name} {p.last_name}</div>
                    <div className="text-xs">{p.primary_position}</div>
                    <div className="text-xs">Score: {p.netstaff_score} · ${p.hourly_rate}/hr</div>
                  </Popup>
                </CircleMarker>
              ) : null
            )}
          </MapContainer>
        </CardContent>
      </Card>
    </div>
  );
}
